// Classes
import { DemographicsReducerState } from "Containers/Filter/Demographics/classes/demographics.classes";
import { AttributeObject } from "../classes/attributes.classes";

// Constants
import { MAPPING_OF_US_REGIONS_TO_US_STATES_AND_TERRITORIES_AND_THEIR_ABBREVIATIONS } from "Containers/Filter/Demographics/Geography/constants/geography.constants";

/**
 * @function getGeographyAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {DemographicsReducerState} demographics - The current state
 * of the Demographics filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getGeographyAttributes(demographics)
 */
export const getGeographyAttributes = (
  demographics: DemographicsReducerState
) => {
  const usaAttributes = [];
  const internationalAttributes = [];

  switch (demographics.geography.usa.selection) {
    case "None":
      usaAttributes.push("None");
      break;
    case "US Regions":
      demographics.geography.usa.value.forEach((region: any) => {
        MAPPING_OF_US_REGIONS_TO_US_STATES_AND_TERRITORIES_AND_THEIR_ABBREVIATIONS[
          region
        ].forEach((state: any) => {
          usaAttributes.push(Object.keys(state)[0]);
        });
      });
      break;
    case "In-State":
      usaAttributes.push("In-State");
      break;
    case "Out-of-State":
      usaAttributes.push("Out-of-State");
      break;
    case "Specific States/Territories":
      demographics.geography.usa.value.forEach((state: any) => {
        usaAttributes.push(state.label);
      });
      break;
  }

  switch (demographics.geography.international.selection) {
    case "None":
      internationalAttributes.push("None");
      break;
    case "Specific Countries":
      demographics.geography.international.value.forEach((country: any) => {
        internationalAttributes.push(country.label);
      });
      break;
  }

  let attributeObject = new AttributeObject(
    `Geography=${usaAttributes.length + internationalAttributes.length}`,
    "geography",
    {
      usa: (usaAttributes.length > 0 && usaAttributes) || [
        "Any USA State or Territory"
      ],
      international: (internationalAttributes.length > 0 &&
        internationalAttributes) || ["Any Country"]
    }
  );

  if (usaAttributes.length === 0 && internationalAttributes.length === 0) {
    attributeObject = undefined;
  }
  return attributeObject;
};
try {
    // @ts-ignore
    getGeographyAttributes.displayName = "getGeographyAttributes";
    // @ts-ignore
    getGeographyAttributes.__docgenInfo = { "description": "", "displayName": "getGeographyAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getGeographyAttributes.ts#getGeographyAttributes"] = { docgenInfo: getGeographyAttributes.__docgenInfo, name: "getGeographyAttributes", path: "src/shared/containers/Attributes/utilities/getGeographyAttributes.ts#getGeographyAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }